<template>
  <div class="panel">
    <b-form-group
      label-for="selection"
    >
      <template #label>
        <div class="d-flex align-items-center">
          <h3 class="mb-0 mr-2">
            {{ $t('bearings.headlineSelection') }}
          </h3>
          <b-button
            id="popover-selection"
            variant="default"
            class="p-0"
            tabindex="-1"
          >
            <font-awesome-icon icon="question-circle" />
          </b-button>
          <b-popover
            target="popover-selection"
            triggers="hover"
            placement="top"
          >
            <template #title>
              {{ $t('bearings.headlineSelectionTooltip') }}
            </template>
            <p>{{ $t('bearings.selectionTooltip') }}</p>
            <!--            <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
          </b-popover>
        </div>
      </template>
    </b-form-group>
    <div
      v-if="warningMessages.length"
      class="alert alert-warning"
    >
      <div class="d-flex">
        <div class="mr-3">
          <font-awesome-icon
            icon="exclamation-triangle"
            class="fa-2x"
          />
        </div>
        <div>
          <p><strong>{{ $t('bearings.introWarningMessages') }}:</strong></p>
          <ul>
            <li
              v-for="(item, i) in warningMessages"
              :key="`warningMessages${i}`"
            >
              {{ $t(`warningCodes.${item}`) }}
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="table-responsive">
      <table class="table table-striped">
        <tbody>
          <tr
            :class="{ 'table-danger': !typ100IsPossibile, 'table-success': typ100IsPossibile }"
          >
            <td class="table-col-type">
              {{ $t('general.type') }} 100
            </td>
            <td class="text-right table-col-possibility">
              <b-badge
                v-if="typ100IsPossibile"
                variant="success"
              >
                {{ $t('general.possible') }}
              </b-badge>
              <b-badge
                v-if="!typ100IsPossibile"
                variant="danger"
              >
                {{ $t('general.notPossible') }}
              </b-badge>
            </td>
            <td class="text-right table-col-recommended">
              <b-badge
                v-if="recommended === 'typ100'"
                variant="info"
              >
                {{ $t('general.recommended') }} *
              </b-badge>
              <span
                v-else
                style="visibility: hidden;"
              >
                {{ $t('general.recommended') }}
              </span>
            </td>
            <td class="text-right table-col-print">
              <b-button
                :disabled="!typ100IsPossibile"
                variant="success"
                size="sm"
                @click="openModal('typ100')"
              >
                {{ $t('general.print') }}
              </b-button>
            </td>
          </tr>
          <tr
            :class="{ 'table-danger': !typ150IsPossibile, 'table-success': typ150IsPossibile }"
          >
            <td class="table-col-type">
              {{ $t('general.type') }} 150
            </td>
            <td class="text-right table-col-possibility">
              <b-badge
                v-if="typ150IsPossibile"
                variant="success"
              >
                {{ $t('general.possible') }}
              </b-badge>
              <b-badge
                v-if="!typ150IsPossibile"
                variant="danger"
              >
                {{ $t('general.notPossible') }}
              </b-badge>
            </td>
            <td class="text-right table-col-recommended">
              <b-badge
                v-if="recommended === 'typ150'"
                variant="info"
              >
                {{ $t('general.recommended') }} *
              </b-badge>
              <span
                v-else
                style="visibility: hidden;"
              >
                {{ $t('general.recommended') }}
              </span>
            </td>
            <td class="text-right table-col-print">
              <b-button
                :disabled="!typ150IsPossibile"
                variant="success"
                size="sm"
                @click="openModal('typ150')"
              >
                {{ $t('general.print') }}
              </b-button>
            </td>
          </tr>
          <tr
            :class="{ 'table-danger': !typ200IsPossibile, 'table-success': typ200IsPossibile }"
          >
            <td class="table-col-type">
              {{ $t('general.type') }} 200
            </td>
            <td class="text-right table-col-possibility">
              <b-badge
                v-if="typ200IsPossibile"
                variant="success"
              >
                {{ $t('general.possible') }}
              </b-badge>
              <b-badge
                v-if="!typ200IsPossibile"
                variant="danger"
              >
                {{ $t('general.notPossible') }}
              </b-badge>
            </td>
            <td class="text-right table-col-recommended">
              <b-badge
                v-if="recommended === 'typ200'"
                variant="info"
              >
                {{ $t('general.recommended') }} *
              </b-badge>
              <span
                v-else
                style="visibility: hidden;"
              >
                {{ $t('general.recommended') }}
              </span>
            </td>
            <td class="text-right table-col-print">
              <b-button
                :disabled="!typ200IsPossibile"
                variant="success"
                size="sm"
                @click="openModal('typ200')"
              >
                {{ $t('general.print') }}
              </b-button>
            </td>
          </tr>
          <!-- <tr
            :class="{ 'table-danger': !pyramideIsPossibile, 'table-success': pyramideIsPossibile }"
          >
            <td>{{ $t('bearings.selectionPyramideBearing') }}</td>
            <td class="text-right">
              <b-badge
                v-if="pyramideIsPossibile"
                variant="success"
              >
                {{ $t('general.possible') }}
              </b-badge>
              <b-badge
                v-if="!pyramideIsPossibile"
                variant="danger"
              >
                {{ $t('general.notPossible') }}
              </b-badge>
            </td>
            <td class="text-right">
              <b-badge
                v-if="recommended === 'pyramide'"
                variant="info"
              >
                {{ $t('general.recommended') }} *
              </b-badge>
            </td>
            <td class="text-right">
              <b-button
                :disabled="!pyramideIsPossibile"
                variant="success"
                size="sm"
                @click="openModal('pyramide')"
              >
                {{ $t('general.print') }}
              </b-button>
            </td>
          </tr> -->
        </tbody>
      </table>
    </div>
    <!--    <p class="text-muted">-->
    <!--      * {{ $t('bearings.selectionRecommended') }}-->
    <!--    </p>-->
    <FixedBearingsModalOutput />
    <b-form-group
      label-for="specific-values"
    >
      <template #label>
        <div class="d-flex align-items-center">
          <h3 class="mb-0 mr-2">
            {{ $t('bearings.bearingESZSpecificValues') }}
          </h3>
          <b-button
            id="popover-specific-values"
            variant="default"
            class="p-0"
            tabindex="-1"
          >
            <font-awesome-icon icon="question-circle" />
          </b-button>
          <b-popover
            target="popover-specific-values"
            triggers="hover"
            placement="top"
          >
            <template #title>
              {{ $t('bearings.headlineSelectionTooltip') }}
            </template>
            <p>{{ $t('bearings.selectionTooltip') }}</p>
            <!--            <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
          </b-popover>
        </div>
      </template>
    </b-form-group>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="table-dark">
          <tr>
            <th class="th-no-border">
              &nbsp;
            </th>
            <th
              colspan="2"
              class="text-center th-no-border"
            >
            </th>
            <th
              colspan="3"
              class="text-center th-no-border"
            >
              {{ $t('bearings.selectionTwistingHeader') }}
            </th>
            <th
              colspan="2"
              class="text-center th-no-border"
            >
              {{ $t('bearings.selectionTransverseTensileForce') }}
              <b-button
                id="popover-lateral-force"
                variant="link"
                class="p-0 align-baseline d-inline-flex align-item-center"
                style="vertical-align: middle; transform: translateY(3px);"
                tabindex="-1"
              >
                <font-awesome-icon
                  icon="question-circle"
                />
              </b-button>
              <b-popover
                target="popover-lateral-force"
                triggers="hover"
                placement="top"
                boundary="viewport"
              >
                <template #title>
                  {{ $t('bearings.transverseTensileForceTooltipHeadline') }}
                </template>
                <p>{{ $t('bearings.transverseTensileForceTooltip') }}</p>
                <!--            <p v-html="$t('general.tooltipAdditionalInfo')"></p>-->
              </b-popover>
            </th>
          </tr>
          <tr>
            <th>&nbsp;</th>
            <th class="text-center">
              σ<sub>z.R𝖽</sub>
            </th>
            <th class="text-center">
              zul. F<sub>𝖽</sub>
            </th>
            <th class="text-center">
              α<sub>𝖺</sub>
            </th>
            <th class="text-center">
              α<sub>b</sub>
            </th>
            <th class="text-center">
              α<sub>Result.</sub>
            </th>
            <th class="text-center">
              Z<sub>𝖺</sub>
            </th>
            <th class="text-center">
              Z<sub>b</sub>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td
              class="text-center font-weight-bold"
              :class="getBearingTypeClass(bearingThickness, 'ESZ', 'typ100')"
            >
              Typ 100
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                compressiveStress, typ100PermissibleCompressiveStress
              ) }"
            >
              <span v-if="!(typ100PermissibleCompressiveStress < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ100PermissibleCompressiveStress > 0 ? typ100PermissibleCompressiveStress : 0) | numeralFormat('0.00') }}
                N/mm<sup>2</sup>
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                power, typ100PermissiblePressureForce
              ) }"
            >
              <span v-if="!(typ100PermissiblePressureForce < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ100PermissiblePressureForce > 0 ? typ100PermissiblePressureForce : 0) | numeralFormat('0.00') }} kN
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalA, typ100PermissibleTwisting.alphaA
              ) }"
            >
              {{ typ100PermissibleTwisting.alphaA | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalB, typ100PermissibleTwisting.alphaB
              )}"
            >
              {{ typ100PermissibleTwisting.alphaB | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger': isExceeded(
                twistingTotal, typ100PermissibleAlphaResulting
              ) }"
            >
              {{ typ100PermissibleAlphaResulting | numeralFormat('0.0') }} &permil;
            </td>
            <td class="text-center">
              {{ transverseTractionEffectA | numeralFormat('0.00') }} kN
            </td>
            <td class="text-center">
              {{ transverseTractionEffectB | numeralFormat('0.00') }} kN
            </td>
          </tr>
          <tr>
            <td
              class="text-center font-weight-bold"
              :class="getBearingTypeClass(bearingThickness, 'ESZ', 'typ150')"
            >
              Typ 150
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                compressiveStress, typ150PermissibleCompressiveStress
              ) }"
            >
              <span v-if="!(typ150PermissibleCompressiveStress < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ150PermissibleCompressiveStress > 0 ? typ150PermissibleCompressiveStress : 0) | numeralFormat('0.00') }}
                N/mm<sup>2</sup>
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                power, typ150PermissiblePressureForce
              ) }"
            >
              <span v-if="!(typ150PermissiblePressureForce < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ150PermissiblePressureForce > 0 ? typ150PermissiblePressureForce : 0) | numeralFormat('0.00') }} kN
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalA, typ150PermissibleTwisting.alphaA
              )}"
            >
              {{ typ150PermissibleTwisting.alphaA | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalB, typ150PermissibleTwisting.alphaB
              )}"
            >
              {{ typ150PermissibleTwisting.alphaB | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger': isExceeded(
                twistingTotal, typ150PermissibleAlphaResulting
              ) }"
            >
              {{ typ150PermissibleAlphaResulting | numeralFormat('0.0') }} &permil;
            </td>
            <td class="text-center">
              {{ transverseTractionEffectA | numeralFormat('0.00') }} kN
            </td>
            <td class="text-center">
              {{ transverseTractionEffectB | numeralFormat('0.00') }} kN
            </td>
          </tr>
          <tr>
            <td
              class="text-center font-weight-bold"
              :class="getBearingTypeClass(bearingThickness, 'ESZ', 'typ200')"
            >
              Typ 200
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                compressiveStress, typ200PermissibleCompressiveStress
              ) }"
            >
              <span v-if="!(typ200PermissibleCompressiveStress < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ200PermissibleCompressiveStress > 0 ? typ200PermissibleCompressiveStress : 0) | numeralFormat('0.00') }}
                N/mm<sup>2</sup>
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                power, typ200PermissiblePressureForce
              ) }"
            >
              <span v-if="!(typ200PermissiblePressureForce < 0)">
                <!-- eslint-disable-next-line max-len -->
                {{ (typ200PermissiblePressureForce > 0 ? typ200PermissiblePressureForce : 0) | numeralFormat('0.00') }} kN
              </span>
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalA, typ200PermissibleTwisting.alphaA
              )}"
            >
              {{ typ200PermissibleTwisting.alphaA | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twisting.totalB, typ200PermissibleTwisting.alphaB
              )}"
            >
              {{ typ200PermissibleTwisting.alphaB | numeralFormat('0.0') }} &permil;
            </td>
            <td
              class="text-center"
              :class="{ 'table-danger' : isExceeded(
                twistingTotal, typ200PermissibleAlphaResulting
              ) }"
            >
              {{ typ200PermissibleAlphaResulting | numeralFormat('0.0') }} &permil;
            </td>
            <td class="text-center">
              {{ transverseTractionEffectA | numeralFormat('0.00') }} kN
            </td>
            <td class="text-center">
              {{ transverseTractionEffectB | numeralFormat('0.00') }} kN
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import FixedBearingsModalOutput from '@/components/fixedBearings/FixedBearingsModalOutput.vue';
import CalcToolsTransverseTractionHelper from '../../helpers/CalcToolsTransverseTractionHelper';

export default {
  name: 'FixedBearingsFormEffects',
  components: {
    FixedBearingsModalOutput,
  },
  // props: {
  //   propBearingWidth: {
  //     type: Number,
  //     default: 100,
  //   },
  //   propBearingLength: {
  //     type: Number,
  //     default: 150,
  //   },
  //   propBearingThickness: {
  //     type: Number,
  //     default: 20,
  //   },
  //   propPower: {
  //     type: Number,
  //     default: 100,
  //   },
  // },
  data() {
    return {
      typ100IsRecommended: true,
      typ150IsRecommended: false,
      typ200IsRecommended: false,
      pyramideIsRecommended: false,
      modalShow: false,
      bearingThicknessOptions: Object.values(this.$dataOptionsHelper.getBearingThicknessOptions()),
      // steelStretchMax: 435,
      // bearingWidth: this.propBearingWidth,
      // bearingLength: this.propBearingLength,
      // bearingThickness: this.propBearingThickness,
      // power: this.propPower,
    };
  },
  computed: {
    ...mapState({
      bearingWidth: state => state.fixedBearingWidth,
      bearingLength: state => state.fixedBearingLength,
      bearingThickness: state => state.fixedBearingThickness,
      power: state => state.fixedBearingPressureForce,
      fixedBearingTwistingA: state => state.fixedBearingTwistingA,
      fixedBearingTwistingB: state => state.fixedBearingTwistingB,
      countHoles: state => state.fixedBearingHolesCount,
      holesDiameter: state => state.fixedBearingHolesDiameter,
    }),
    ...mapGetters([
      'warningMessages',
      'typ100PermissibleCompressiveStress',
      'typ100PermissibleTwisting',
      'typ100PermissibleAlphaResulting',
      'typ100IsPossibile',
      'typ100PermissiblePressureForce',
      'typ150PermissibleCompressiveStress',
      'typ150PermissibleTwisting',
      'typ150PermissibleAlphaResulting',
      'typ150IsPossibile',
      'typ150PermissiblePressureForce',
      'typ200PermissibleCompressiveStress',
      'typ200PermissibleTwisting',
      'typ200PermissibleAlphaResulting',
      'typ200IsPossibile',
      'typ200PermissiblePressureForce',
      'pyramideIsPossibile',
      'twistingTotal',
      'twisting',
    ]),
    compressiveStress() {
      return CalcToolsTransverseTractionHelper.getCompressiveStress(
        this.bearingWidth,
        this.bearingLength,
        this.$outputHelper.convertToInteger(this.power),
        this.countHoles,
        this.holesDiameter,
      );
    },
    // effectUprightFactor() {
    //   return CalcToolsTransverseTractionHelper.getEffectUprightFactor(
    //     this.bearingWidth,
    //     this.bearingLength,
    //     this.$outputHelper.convertToInteger(this.power) * 1000,
    //   );
    // },
    transverseTractionEffectA() {
      return CalcToolsTransverseTractionHelper.getTransverseTractionA(
        this.bearingWidth,
        this.bearingLength,
        this.bearingThickness,
        this.power,
        this.compressiveStress,
      );
    },
    transverseTractionEffectB() {
      return CalcToolsTransverseTractionHelper.getTransverseTractionB(
        this.bearingWidth,
        this.bearingLength,
        this.bearingThickness,
        this.power,
        this.compressiveStress,
      );
    },
    recommended() {
      let bearingType = '';
      /* if (this.pyramideIsPossibile) {
        bearingType = 'pyramide';
      } else */
      if (
        /* !this.pyramideIsPossibile
        && */
        this.typ100IsPossibile
      ) {
        bearingType = 'typ100';
      } else if (
        /* !this.pyramideIsPossibile
        &&  */
        !this.typ100IsPossibile
        && this.typ150IsPossibile
      ) {
        bearingType = 'typ150';
      } else if (
        /* !this.pyramideIsPossibile
        && */
        !this.typ100IsPossibile
        && !this.typ150IsPossibile
        && this.typ200IsPossibile
      ) {
        bearingType = 'typ200';
      }
      return bearingType;
    },
  },
  methods: {
    openModal(type) {
      this.$store.commit('fixedBearingSelectedBearingType', type);
      this.$bvModal.show('modalOutput');
    },
    isExceeded(actual, permissible) {
      return actual > permissible;
    },
    getBearingTypeClass(bearingThickness, formBearingType, typ) {
      // unter Mindestdicke → neutral
      if (bearingThickness < 25) {
        return null;
      }

      // gültige Kombination → grün
      if (typ === 'typ100' && formBearingType === 'ESZ') {
        return null;
      }

      // sonst ungültig → rot
      return 'table-danger';
    },
  },
};
</script>

<style scoped lang="scss">
  .table-col-type {
    width: 25%;
  }
  .table-col-possibility {
    width: 25%;
  }
  .table-col-recommended {
    width: 25%;
  }
  .table-col-print {
    width: 25%;
  }
  .th-no-border {
    border-bottom: none;
  }
</style>
